import { api, isDefined, isTruthy } from 'common';

const TagCategory = api.FlowDefinitionTemplate.TagCategory;

interface TagWithCategory extends Omit<api.FlowDefinition.FlowTag, 'category'> {
  category: api.FlowDefinitionTemplate.TagCategory;
}

interface FormDataTags {
  useCaseTag?: string | null;
  flowTypeTag?: string | null;
  supportedEhrTags?: string[] | null;
  customTags?: string[] | null;
  noCategoryTags?: string[] | null;
}

export function convertTagsToApiValue(
  args: Omit<FormDataTags, 'noCategoryTags'>
): TagWithCategory[] {
  const { useCaseTag, flowTypeTag, supportedEhrTags, customTags } = args;

  const tags: TagWithCategory[] = [];
  if (isDefined(useCaseTag)) {
    tags.push({ name: useCaseTag, category: TagCategory.UseCase });
  }
  if (isDefined(flowTypeTag)) {
    tags.push({ name: flowTypeTag, category: TagCategory.FlowType });
  }
  if (isDefined(supportedEhrTags)) {
    tags.push(
      ...supportedEhrTags.map((tag) => ({ name: tag, category: TagCategory.SupportedEhr }))
    );
  }
  if (isDefined(customTags)) {
    tags.push(...customTags.map((tag) => ({ name: tag, category: TagCategory.Custom })));
  }
  return tags;
}

export function convertTagsToFormData(args: {
  tags?: api.FlowDefinition.FlowTag[] | null;
}): FormDataTags {
  const { tags } = args;
  if (!isDefined(tags)) {
    return {};
  }

  const useCaseTag = tags.find((tag) => tag.category === TagCategory.UseCase);
  const flowTypeTag = tags.find((tag) => tag.category === TagCategory.FlowType);
  const supportedEhrTags = tags.filter((tag) => tag.category === TagCategory.SupportedEhr);
  const customTags = tags.filter((tag) => tag.category === TagCategory.Custom);
  const noCategoryTags = tags.filter((tag) => !isDefined(tag.category));

  return {
    useCaseTag: useCaseTag?.name,
    flowTypeTag: flowTypeTag?.name,
    supportedEhrTags: isTruthy(supportedEhrTags.length)
      ? supportedEhrTags.map((tag) => tag.name)
      : undefined,
    customTags: isTruthy(customTags.length) ? customTags.map((tag) => tag.name) : undefined,
    noCategoryTags: isTruthy(noCategoryTags.length)
      ? noCategoryTags.map((tag) => tag.name)
      : undefined,
  };
}
